module.exports = __webpack_public_path__ + "static/img/Badge.c647fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/Badge.png
// module id = 1tWK
// module chunks = 0